var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('div',{staticClass:"margin-top-30"},[_c('tl-tabs',{attrs:{"tabs":_vm.tabs,"customclass":true}},[_c('tl-tab',[_c('upload-fbp-claims')],1),_c('tl-tab',[_c('fbp-claim-history')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }